module.exports = __webpack_public_path__ + "static/media/GiantLanternINTA0036_design_clean_v002.727a05d4.png";